import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { MembershipGroup } from 'src/features/memberships/types';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/membership-groups/';

interface DTO extends ListDTO {
    parkingId: string;
    reservation_type?: 'NORMAL' | 'ALL' | 'ONLINE';
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<MembershipGroup>> => {
    // Custom core filtering
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            (params as Record<string, any>)[key] = value.join(',');
        }
    });

    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_MEMBERSHIP_GROUPS_RESOURCE,
    queryFn as listMembershipGroups,
    useQueryHook as useListMembershipGroups,
};
export type { DTO as ListMembershipGroupsDTO };
